import { render } from "./TextMediaFull.vue?vue&type=template&id=e55a8fde"
import script from "./TextMediaFull.vue?vue&type=script&lang=js"
export * from "./TextMediaFull.vue?vue&type=script&lang=js"

import "./TextMediaFull.vue?vue&type=style&index=0&id=e55a8fde&lang=scss"
script.render = render

export default script